(ns motorsaif.web.admin-events
  (:require
   [motorsaif.log :as log]
   [motorsaif.shared.interceptors :as ic]
   [motorsaif.string :as string :refer [format]]
   [re-frame.core :as rf]))

(rf/reg-event-fx :admin/post-translation
  (fn [_cofx [_ data]]
    {:ajax {:type :POST
            :id :admin/translation
            :url "/api/admin/translation"
            :params {:data data}
            :handler [:toast {:type "success"
                              :message "Saved"}]}}))

(rf/reg-event-fx :admin/fetch-data
  [ic/trace-fetch-status]
  (fn [_ [_ data]]
    (let [{:keys [_id]} data]
      {:ajax {:type    :GET
              :id      :admin-data
              :url     "/api/admin/data"
              ;; (rf/dispatch  [:common/navigate! :home])
              :error-handler #(rf/dispatch [:toast {:message "Getout"}])
              :handler (fn [{:keys [data]}]
                         (doall (map (fn [[k v]]
                                       (rf/dispatch [:merge-db-id-coll [:admin-data k] v]))
                                     data)))}})))

(rf/reg-event-fx :admin/dev-login
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ _]
    {:ajax {:type :GET
            :id   :login-admin
            :url  "/api/login-admin"
            :handler (fn [_]
                       (js/window.location.reload))}}))

(rf/reg-event-fx :admin/fetch-request-data
  [ic/trace-fetch-status]
  (fn [_ [_ request-id]]
    {:ajax {:type    :GET
            :id      :admin-data
            :url     (format "/api/admin/request-data/%s" request-id)
            ;; (rf/dispatch  [:common/navigate! :home])
            :error-handler #(rf/dispatch [:toast {:message "Getout"}])
            :handler (fn [ret]
                       (rf/dispatch [:assoc-data [:admin-request-data request-id] ret]))}}))

(rf/reg-event-fx :admin/send-request-notification
  (fn [_cofx [_ {:keys [webpush-id request-id business-id type] :as args}]]
    (assert (and type
                 request-id
                 (or
                  business-id ; business whatsapp
                  (and
                   (= type :webpush)
                   business-id
                   webpush-id) ; user webpush
                  )))
    (assert (#{:email :whatsapp :webpush} type))
    {:ajax {:type :POST
            :id :admin/request-notification
            :url "/api/admin/send-request-notification"
            :params {:data args}
            :handler (fn [{:keys [touch-ret sent-ret link] :as res}]
                       (if touch-ret
                         (rf/dispatch [:toast {:message "Sent"}])
                         (rf/dispatch [:toast {:message "Not Sent"}]))
                       (log/info [:srn-res res]))}}))
